import {Component, Input, OnInit} from '@angular/core';
import {ProductService} from "../../../../services/product.service";
import {Product} from "../../../../models/product";
import {environment} from "../../../../../../environments/environment";

@Component({
    selector: 'app-product-attr-box',
    templateUrl: './product-attr-box.component.html',
    styleUrls: ['./product-attr-box.component.css']
})
export class ProductAttrBoxComponent implements OnInit {

    @Input('sku') sku;

    attrs =null;

    constructor(public productService: ProductService) {
    }

    ngOnInit(): void {

        this.getProductAttributesTable();

    }


    getProductAttributesTable() {


        this.productService.getProductsAttributes(this.sku,environment.store_id).subscribe(result => {

            this.attrs = result;

        });

    }

}
